import * as React from 'react';
import { SelectItem } from 'vet-bones/utils/select';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { addDomainToAttributeModelData } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/addDomainToAttributeModelData';
import { removeDomainFromAttributeModelData } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/removeDomainFromAttributeModelData';
import { addModelConceptClass } from 'src/containers/ProjectDiagram/utils/modelConceptClass/addModelConceptClass';
import { getProjectModelIdsForIri } from 'src/containers/ProjectDiagram/utils/projectModelIds';

export const useAddClassToAttribute = (attributeIri?: string) => {
  const diagram = useDiagram();

  return React.useCallback(
    (item: SelectItem | null) => {
      if (!item || !diagram || !attributeIri) {
        return;
      }

      const { isNewlyCreated, text, value } = item;

      const commitFn = (model: Model) => {
        if (isNewlyCreated) {
          addModelConceptClass({
            iri: value,
            label: text,
            projectModelIds: getProjectModelIdsForIri(attributeIri, model),
          })(model);
        }
        addDomainToAttributeModelData({
          value: attributeIri,
          domain: value,
        })(model);
      };

      commitDiagramModel(diagram, commitFn);
    },
    [attributeIri, diagram]
  );
};

export const useRemoveClassFromAttribute = (attributeIri?: string) => {
  const diagram = useDiagram();

  return React.useCallback(
    (classIri: string) => {
      if (!diagram || !attributeIri) {
        return;
      }
      commitDiagramModel(
        diagram,
        removeDomainFromAttributeModelData({
          domain: classIri,
          value: attributeIri,
        })
      );
    },
    [attributeIri, diagram]
  );
};
